// src/views/components/Motion/SplitText.jsx
import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

const SplitText = ({
  text,
  className = '',
  style = {},
  delay = 0,
  stagger = 0.05,
  as: Component = 'h1',
}) => {
  const shouldReduceMotion = useReducedMotion();

  if (typeof text !== 'string') {
    return <Component className={className} style={style}>{text}</Component>;
  }

  const words = text.split(' ');

  if (shouldReduceMotion) {
    return <Component className={className} style={style}>{text}</Component>;
  }

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: stagger,
        delayChildren: delay,
      },
    },
  };

  const wordVariants = {
    hidden: { opacity: 0, y: 24, filter: 'blur(6px)' },
    visible: {
      opacity: 1,
      y: 0,
      filter: 'blur(0px)',
      transition: {
        duration: 0.5,
        ease: [0.2, 0.65, 0.3, 0.9],
      },
    },
  };

  return (
    <Component className={className} style={{ display: 'inline-block', ...style }}>
      <motion.span
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        style={{ display: 'inline-wrap', flexWrap: 'wrap' }}
      >
        {words.map((word, i) => (
          <motion.span
            key={i}
            variants={wordVariants}
            style={{
              display: 'inline-block',
              marginRight: i === words.length - 1 ? '0' : '0.25em',
              willChange: 'transform, opacity, filter',
            }}
          >
            {word}
          </motion.span>
        ))}
      </motion.span>
    </Component>
  );
};

export default SplitText;
